import React from "react";
import NumberFormat from "react-number-format";
import { IProviderAddon } from "../../../../compare/interfaces/IProviderAddon";

//styles
import cx from "classnames";
import styles from "../QuoteBreakdownClientBenefits/QuoteBreakdownClientBenefits.module.scss";



interface IQuoteBreakdownAddOnProps {
    providerAddOn: IProviderAddon,
    addOnPremium: number,
    isChild: boolean
}

const BreakdownRow: React.FC<{ title: React.ReactNode; value: number }> = ({
    title,
    value
}) => {
    return (
        <div
            className={cx(styles["apply-result-section--line-item"], "text-font-size-s")}>
            <div className={cx("text-primary")}>{title}</div>
            <NumberFormat
                value={value}
                prefix={"$"}
                displayType={"text"}
                thousandSeparator
                isNumericString
                decimalScale={2}
                fixedDecimalScale
                className={cx("text-primary", {
                    ["text-brand"]: value < 0
                })}
            />
        </div>
    );
};

const QuoteBreakdownAddOn: React.FC<IQuoteBreakdownAddOnProps> = (
    props
) => {
    const { providerAddOn, addOnPremium, isChild} = props;

    const hasBreakdownList = providerAddOn.breakdownList != null && providerAddOn.breakdownList.length != 0;
    
    const hasDiscount = providerAddOn.discountPercentage > 0;

    return (
        <React.Fragment>
            {!isChild ? < div className={cx("padding-vertical-m", styles["container"])}>
                {hasBreakdownList &&
                    providerAddOn.breakdownList.map((b, index) => {
                        return (
                            <BreakdownRow
                                key={index}
                                title={b.text}
                                value={b.value}
                            />
                        );
                    })
                }
                {hasDiscount &&
                    <BreakdownRow
                        title={"Premium Discount"}
                        value={addOnPremium}
                    />
                }
            </div> :
            <div className={cx(
                    styles["apply-result-section--line-item"],
                    "text-italic"
                )}>
                Not covered
            </div>
            }
        </React.Fragment>
    );
};

export default QuoteBreakdownAddOn;
